import React, { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://hollywoodchamber.chambermaster.com/Content/Script/Member.js";
const MEMBER_ID = 10644;
const WIDGET_ID = "mni-membership-639267743193453386";

const STYLE_TEMPLATE =
  "#@id{display:inline-flex;align-items:center;gap:14px;position:relative}" +
  "#@id a{color:#fff;text-decoration:none;display:inline-flex;align-items:center;gap:14px}" +
  "#@id .mn-widget-member-name{font-family:'Space Grotesk',system-ui,sans-serif;font-weight:800;font-size:14px;letter-spacing:-0.01em;color:#fff;text-transform:none;order:2}" +
  "#@id .mn-widget-member-text{font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:10px;letter-spacing:0.3em;text-transform:uppercase;color:#D4AF37;order:1}" +
  "#@id .mn-widget-member-assoc{order:3;display:inline-flex;align-items:center}" +
  "#@id .mn-widget-member-logo,#@id .mn-widget-member-assoc img{max-width:120px;max-height:40px;filter:brightness(1.15) saturate(0)}";

function loadScript() {
  return new Promise((resolve) => {
    if (window.MNI && window.MNI.Widgets && window.MNI.Widgets.Member) return resolve();
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      return;
    }
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => resolve();
    document.body.appendChild(s);
  });
}

export default function ChamberBadge() {
  const ref = useRef(null);

  useEffect(() => {
    let cancelled = false;
    loadScript().then(() => {
      if (cancelled) return;
      if (!ref.current) return;
      // Clear any previous render (hot-reload)
      ref.current.innerHTML = "";
      try {
        // eslint-disable-next-line no-new
        new window.MNI.Widgets.Member(WIDGET_ID, {
          member: MEMBER_ID,
          styleTemplate: STYLE_TEMPLATE,
        }).create();
      } catch (e) {
        console.error("Chamber widget failed to render", e);
      }
    });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="flex justify-center">
      <div
        className="inline-flex items-center gap-4 border border-[var(--primary)]/40 bg-[var(--primary)]/5 px-5 py-3 hover:border-[var(--primary)]/70 transition-colors"
        data-testid="hollywood-chamber-badge"
      >
        <div className="w-1.5 h-1.5 bg-[var(--primary)]" />
        <div id={WIDGET_ID} ref={ref} className="min-h-[40px] flex items-center" />
        {/* Fallback visible until widget mounts / if JS blocked */}
        <noscript>
          <a
            href="https://hollywoodchamber.chambermaster.com/list/member/e-quantum-consults-10644"
            className="font-heading font-bold text-sm tracking-tight text-white"
            target="_blank"
            rel="noopener noreferrer"
          >
            Proud Member — Hollywood Chamber of Commerce
          </a>
        </noscript>
      </div>
    </div>
  );
}
